import ReactDOM from "react-dom";
import store from "./app/store";
import { Provider } from "react-redux";
import Router from "./routes/router";
import { GlobalStyle } from "./styles/global.style";
import "antd/dist/antd.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

ReactDOM.render(
  <Provider store={store}>
    <GlobalStyle />
    <Router />
  </Provider>,
  document.getElementById("root")
);
